import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import {
  Sport,
  SubscribableType,
} from '@sorare/core/src/__generated__/globalTypes';

import type { useHasFollowedPlayers_currentUser } from './__generated__/useHasFollowedPlayers.graphql.ts';

type Props = {
  currentUser: Nullable<useHasFollowedPlayers_currentUser>;
};

export const getSubscribableWatchlistTypes = (sport: Sport) => {
  switch (sport) {
    case Sport.NBA:
      return [SubscribableType.NBA_PLAYER];
    case Sport.BASEBALL:
      return [SubscribableType.BASEBALL_PLAYER];
    case Sport.FOOTBALL:
    default:
      return [SubscribableType.PLAYER];
  }
};

export const useHasFollowedPlayers = ({ currentUser }: Props) => {
  return {
    hasFollowedPlayers: (currentUser?.mySubscriptions?.nodes?.length || 0) > 0,
    followedPlayers: currentUser?.mySubscriptions?.nodes?.map(
      node => node.anySubscribable
    ),
    count: currentUser?.mySubscriptions?.totalCount || 0,
  };
};

useHasFollowedPlayers.fragments = {
  currentUser: gql`
    fragment useHasFollowedPlayers_currentUser on CurrentUser {
      slug
      mySubscriptions(types: $types, first: 7) {
        nodes {
          slug
          anySubscribable {
            slug
            ... on AnyPlayerInterface {
              slug
              fullPictureUrl
            }
          }
        }
        totalCount
      }
    }
  ` as TypedDocumentNode<useHasFollowedPlayers_currentUser>,
};
